import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlocksModule } from '../../blocks/blocks.module';
import { SharedModule } from '../../shared';
import { physicalTherapySessionComponent } from './physical-therapy-session.component';
import { physicalTherapySessionRoutingModule } from './physical-therapy-session.routing';
import { PhysiotherapySessionService } from './physical-therapy-session.service';
import { FastSearchModule } from '../../blocks/ui-component/fast-search/fast-search.module';
import { BreadcrumbModule } from '../../blocks/breadcrumb/breadcrumb.module';
import { ModalContainerModule } from "../../blocks/ui-component/modal-container/modal-container.module";
import { docuMangeNewgModule } from '../../docu-manage-new/docu-manage-new.module';



@NgModule({
    declarations: [
        physicalTherapySessionComponent,
    ],
    providers: [
        PhysiotherapySessionService,
    ],
    exports: [
        physicalTherapySessionComponent,
    ],
    imports: [
        CommonModule,
        BlocksModule,
        SharedModule,
        physicalTherapySessionRoutingModule,
        FastSearchModule,
        BreadcrumbModule,
        ModalContainerModule,
        docuMangeNewgModule
    ]
})
export class physicalTherapySessionModule { }
